import { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import bn from '../locales/bn';
import en from '../locales/en';

const translations = { bn, en };

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('bhumi_lang') || 'bn';
  });

  useEffect(() => {
    localStorage.setItem('bhumi_lang', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        value = translations['bn'];
        for (const k2 of keys) {
          if (value && value[k2]) {
            value = value[k2];
          } else {
            return key;
          }
        }
        break;
      }
    }
    
    return value;
  }, [language]);

  const toggleLanguage = useCallback(() => {
    setLanguage(prev => prev === 'bn' ? 'en' : 'bn');
  }, []);

  const value = useMemo(() => ({
    language, setLanguage, toggleLanguage, t
  }), [language, toggleLanguage, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
